<script>
  let { user, onSave, onCancel } = $props();

  let haslo = $state(Math.random().toString(36).slice(2, 10));
  let submitted = $state(false);

  function ok(event) {
    event.preventDefault();
    submitted = true;
    if (haslo) {
      onSave({ idau: user.idau, haslo });
    }
  }
</script>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">Ustaw nowe hasło</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form class="form form-inline" role="form" onsubmit={ok}>
            <table class="table table-condensed table-hover table-striped">
			<tbody>
			  <tr>
				<td>
				Login:
				</td>
                <td>
				{user.login}
				</td>
			  </tr>
			  <tr>
				<td>
				Imię i nazwisko:
				</td>
                <td>
				{user.nazwa}
				</td>
			  </tr>
			  <tr>
				<td>
				Rola:
				</td>
                <td>
                {user.rola}
				</td>
			  </tr>
              <tr>
				<td>
				Ustaw hasło:
				</td>
                <td>
                <input type="text" class="form-control input-sm" placeholder="haslo" bind:value={haslo} size="40" required>
				{#if submitted && !haslo}
				<small style="color:red">Trzeba wpisać nowe hasło</small>
				{/if}
				</td>
			  </tr>
			</tbody>
			</table>
            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success" onclick={ok}>Zapisz</button>
  <button class="btn btn-default" onclick={onCancel}>Anuluj</button>
</div>
